import { jsx } from "react/jsx-runtime";
import { Box } from "@zillow/constellation-10";
import abtest from "@zillow/mortgage-abtest";
import Questionnaire from "@zillow/mortgage-questionnaire";
import { zillowURL } from "@zillow/url";
import { useState, useEffect, useMemo } from "react";
import MortgagePageClassification from "../../utils/mortgagehelpers/MortgagePageClassification.esm.js";
import { getMapObject, mapLongTableInput } from "./MortgageQuestionnare.util.esm.js";
const LOAN_TYPE_PURCHASE = "purchase";
const ZGMI_PURCHASE_RATES_ROUTING_IN_CONNECT = "ZGMI_PURCHASE_RATES_ROUTING_IN_CONNECT";
const ZGMI_PURCHASE_RATES_ROUTING_IN_CONNECT_VARIANT = "VARIANT";
const QUOTES_PAGE_URL_PATH = `mortgage-rates/quotes/`;
const MORTGAGE_QUESTIONNAIRE_KEY = "mortgage-questionnaire";
const buildResultsUrl = () => {
  const storedAnswers = getMapObject(MORTGAGE_QUESTIONNAIRE_KEY) ?? {};
  if (Object.keys(storedAnswers).length === 0) {
    return zillowURL(QUOTES_PAGE_URL_PATH);
  }
  const newUrlParams = mapLongTableInput(storedAnswers);
  return zillowURL(QUOTES_PAGE_URL_PATH + `?${new URLSearchParams(newUrlParams).toString()}`);
};
const MortgageQuestionnaire = ({
  pathName,
  landingPage
}) => {
  const [started, setStarted] = useState(false);
  const [source, setSource] = useState(null);
  useEffect(() => {
    const waitingOnOptimize = async () => {
      await abtest.waitOnOptimize();
    };
    waitingOnOptimize();
    setSource(new URLSearchParams(window.location.search).get("source"));
  }, []);
  const classification = new MortgagePageClassification(pathName ?? "/mortgage-rates/");
  const {
    loanType
  } = classification;
  const resultsUrl = useMemo(() => buildResultsUrl(), []);
  return /* @__PURE__ */ jsx(Box, { css: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, children: /* @__PURE__ */ jsx(Questionnaire, { context: {
    entry: "cq",
    originalEntry: "cq",
    // title: header,
    // description: paraGraph,
    loanType,
    landingPage: landingPage ?? "mortgage-rates",
    source
  }, storageKey: MORTGAGE_QUESTIONNAIRE_KEY, onRouteChange: ({
    lastKey,
    answers,
    isInit
  }) => {
    var _a, _b;
    if (isInit) {
      return;
    }
    if (!started) {
      setStarted(true);
      (_b = (_a = global.DD_RUM) == null ? void 0 : _a.addAction) == null ? void 0 : _b.call(_a, "mortgage-questionnaire:started", {
        entry: "CQ",
        startedWith: lastKey
      });
    }
    abtest.getTreatment(ZGMI_PURCHASE_RATES_ROUTING_IN_CONNECT) === ZGMI_PURCHASE_RATES_ROUTING_IN_CONNECT_VARIANT && (answers == null ? void 0 : answers.loanType) === LOAN_TYPE_PURCHASE;
  }, showProgress: false, showLanding: true, resultsUrl }) });
};
export {
  MortgageQuestionnaire as default
};
